<template>
  <div class="py-4">
    <h3 class="text-lg font-bold text-gray-900 mb-4 text-center">
      {{ $t('reborn.faq.title') }}
    </h3>
    <div class="space-y-3">
      <div
        v-for="(faq, index) in faqList"
        :key="index"
        class="border border-gray-200 rounded-lg overflow-hidden"
      >
        <div
          class="p-3 cursor-pointer transition-colors"
          :class="
            openFaqIndexes.includes(index)
              ? 'bg-primary/5'
              : 'sm:hover:bg-gray-50'
          "
          @click="toggleFaq(index)"
        >
          <div class="flex justify-between items-center">
            <span
              class="text-sm font-medium pr-2"
              :class="
                openFaqIndexes.includes(index)
                  ? 'text-primary'
                  : 'text-gray-800'
              "
            >
              {{ faq.q }}
            </span>
            <span
              class="text-xs text-gray-500 transform transition-transform flex-shrink-0"
              :class="openFaqIndexes.includes(index) ? 'rotate-180' : ''"
            >
              ▼
            </span>
          </div>
        </div>

        <div
          class="overflow-hidden transition-all duration-300"
          :class="
            openFaqIndexes.includes(index)
              ? 'max-h-48 opacity-100'
              : 'max-h-0 opacity-0'
          "
        >
          <div class="p-3 text-xs text-gray-600 border-t border-gray-100">
            <div
              v-if="faq.name === 'why-better'"
              v-html="$t('reborn.faq.whyBetter')"
            />
            <div v-else v-html="faq.a" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaymentPaywallModalFaq',

  data: () => ({
    openFaqIndexes: []
  }),

  computed: {
    faqList() {
      return this.$t('reborn.faq.questions')
    }
  },

  methods: {
    toggleFaq(index) {
      if (this.openFaqIndexes.includes(index)) {
        this.openFaqIndexes = this.openFaqIndexes.filter(i => i !== index)
      } else {
        this.openFaqIndexes.push(index)
      }
    }
  }
}
</script>
